import { useRequest } from "ahooks";
import OrderDTO from "@/dto/order/OrderDTO";
import { deleteMarkToOrder } from "@/services/api/order";

export default function useDeleteMarkRequest() {
    return useRequest(
        async (order: OrderDTO) => {
            const orderIds = [order.id];

            if (order.childOrders?.length) {
                orderIds.push(...order.childOrders.map((order) => order.id));
            }

            return deleteMarkToOrder({
                shopId: order.shopId,
                orderIds,
            });
        },
        {
            manual: true,
        },
    );
}
